<template>
  <b-modal v-model="modalTag" :width="448">
    <div class="card" style="width: auto">
      <header class="modal-card-head">
        <h3 class="modal-card-title is-size-4 has-text-weight-medium">
          Tags
        </h3>
        <button
          type="button"
          class="delete"
          @click="modalTag = false"
        />
      </header>
      <section class="modal-card-body">
        <b-table
          :loading="isLoading"
          hoverable
          striped
          :data="results"
        >
          <b-table-column label="Nombre" field="name" v-slot="props">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column v-slot="props">
            <div class="has-text-right">
              <b-checkbox
                :id="props.row.id"
                :native-value="{ id: props.row.id, name: props.row.name }"
                v-model="checkedRows"
              />
            </div>
          </b-table-column>
          <loading-table slot="empty" :isLoading="isLoading" />
        </b-table>
        <div class="m-4 has-text-right">
          <small>
            <b>Total Seleccionados</b>: {{ checkedRows.length }}
          </small>
        </div>
        <Pages
          :links="links"
          :pages="pages"
          v-if="pages"
          @set-link="setLink"
          @set-page="setPage"
        ></Pages>
      </section>
      <footer class="modal-card-foot">
        <b-button
          label="Guardar"
          type="is-primary"
          :loading="isLoading"
          :disabled="isLoading"
          @click="saveData"
        />
        <b-button
          label="Cerrar"
          type="is-dark"
          @click="modalTag = false"
        />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ProductService from '@/services/ProductService'
import Pages from '@/components/Pages'
import LoadingTable from '@/components/Base/LoadingTable'
export default {
  name: 'ModalTag',
  props: {
    prevCheckedRows: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Pages,
    LoadingTable
  },
  data () {
    return {
      modalTag: true,
      isLoading: false,
      results: [],
      links: {},
      pages: {},
      checkedRows: []
    }
  },
  watch: {
    modalTag () {
      this.$emit('hidden')
    }
  },
  created () {
    this.checkedRows = this.prevCheckedRows
    this.getProductTagList()
  },
  methods: {
    errorMessage (message = 'Ocurrió un error', type = 'is-danger') {
      this.$buefy.toast.open({
        message,
        type
      })
    },
    async getProductTagList (params = {}) {
      try {
        this.isLoading = true
        const response = await ProductService.getProductTagList(params)
        this.results = response.data.results
        this.pages = response.data.pages
        this.pages.per_page = 7
        this.links = response.data.links
      } catch (error) {
        this.errorMessage()
      }
      this.isLoading = false
    },
    setLink () {
      this.getProductTagList()
    },
    setPage (page) {
      this.getProductTagList({ page: page })
    },
    saveData () {
      if (this.checkedRows.length > 0) {
        this.$emit('tagList', this.checkedRows)
        this.modalTag = false
      } else {
        const message = 'Seleccione una o más opciones'
        this.errorMessage(message)
      }
    }
  }
}
</script>
